import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConstantValues } from '../bpg-common/models/bpg-constants';
import { map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { BpgCommonService } from '../bpg-common/services/bpg-common.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';


const EXCEL_TYPE = 'application/csv;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class BpgEventsService {

  constructor(private readonly http: HttpClient,
    // private logger:BPGLoggerService,
    private readonly bpgCommonService: BpgCommonService) { }

  URI: string = ConstantValues.eventManagementApiUrl.eventManagementUrl;
  userUrl: string = ConstantValues.userManagementApiUrl.userManagementUrl;
  eventListApi: string = ConstantValues.eventManagementApiUrl.eventCalendarList;
  chapterDropDownListApi: string = ConstantValues.commonApiUrl.eventChapterDropDownList;
  eventTypeListForDropDownApi: string = ConstantValues.eventManagementApiUrl.eventTypeList;
  hoshinListForDropDownApi: string = ConstantValues.eventManagementApiUrl.hoshinList;
  createEventApi: string = ConstantValues.eventManagementApiUrl.createEvent;
  uploadFileApi: string = ConstantValues.eventManagementApiUrl.uploadFile;
  getAwsUrl: string = ConstantValues.eventManagementApiUrl.awsUrls;
  evevntRegistrationApi: string = ConstantValues.eventManagementApiUrl.eventRegistration;
  eventRegistrationForGroupApi: string = ConstantValues.eventManagementApiUrl.eventRegistrationForGroup;
  evevntAttendanceApi: string = ConstantValues.eventManagementApiUrl.eventAttendance;
  getCountOfSignedUserByEventId: string = ConstantValues.eventManagementApiUrl.countOfSignedUser;
  getSignedUnsignedUserByEventId: string = ConstantValues.eventManagementApiUrl.signedUnsignedUser;
  eventStatusUpdateApi: string = ConstantValues.eventManagementApiUrl.eventStatusUpdate;
  expenseStatusUpdateApi: string = ConstantValues.eventManagementApiUrl.expenseStatusUpdate;
  surveyStandardQuestionAnswersApi: string = ConstantValues.eventManagementApiUrl.getSurveyStandardQuestionAnswers;
  takeSurveyListApi: string = ConstantValues.eventManagementApiUrl.getTakeSurveyList;
  saveSurveyResponseApi: string = ConstantValues.eventManagementApiUrl.saveSurveyResponse;
  createSurveyApi: string = ConstantValues.eventManagementApiUrl.createSurvey;
  getSurveyIdApi: string = ConstantValues.eventManagementApiUrl.getSurveyId;
  getSurveyQuestionsApi: string = ConstantValues.eventManagementApiUrl.getSurveyQuestions;
  suveyTakenByUserApi: string = ConstantValues.eventManagementApiUrl.suveyTakenByUser;
  listAttendanceApi: string = ConstantValues.eventManagementApiUrl.listAttendance;
  listEventReportApi: string = ConstantValues.eventManagementApiUrl.getEventReport;
  getGroupSignupDetailsApi : string =  ConstantValues.eventManagementApiUrl.getGroupSignupDetails;
  removeFromEventGroupApi : string =  ConstantValues.eventManagementApiUrl.removeFromEventGroup;
  printEventListApi: string = ConstantValues.eventManagementApiUrl.printEventsInFY;
  getBudgetActualsDataApi : string = ConstantValues.eventManagementApiUrl.getBudgetActualsData;  
  /** For service call to get all Events
 * @class EventCalendarService
 * @method getAllEvents
 * @param landingData
 * @returns Observable
 */

  public getAllEvents(landingData: any): Observable<any> {
    return this.http.post(this.URI + this.eventListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }

  /** For service call to get all Chapter dropdown
   * @class EventCalendarService
   * @method getChapterDropDown
   * @param landingData
   * @returns Observable
   */

  public getChapterDropDown(userAndRoleIdDTO: any): Observable<any> {

    return this.http.post(this.userUrl + this.chapterDropDownListApi, userAndRoleIdDTO, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to get all Chapter dropdown
 * @class EventCalendarService
 * @method getEventTypeListForDropDown
 * @param 
 * @returns Observable
 */

  public getEventTypeListForDropDown(): Observable<any> {

    return this.http.post(this.URI + this.eventTypeListForDropDownApi, {}, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }


  /** For service call to get all hoshin dropdown
* @class EventCalendarService
* @method getHoshinListForDropDown
* @param 
* @returns Observable
*/

  public getHoshinListForDropDown(landingDTOModel: any): Observable<any> {

    return this.http.post(this.URI + this.hoshinListForDropDownApi, landingDTOModel, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }


  /** For service call to save event
* @class EventCalendarService
* @method saveEvent
* @param eventFormData
* @returns Observable
*/

  public saveEvent(eventFormData: any): Observable<any> {

    return this.http.post(this.URI + this.createEventApi, eventFormData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }



  /** For service call to upload file
* @class EventCalendarService
* @method uploadFile
* @param eventFormData
* @returns Observable
*/

  public uploadFile(files: File[], action: string, id: string): Observable<any> {
    const formdata: FormData = new FormData();
    for (const file of files) {
      formdata.append('file', file);
    }
    formdata.append('action', action);
    formdata.append('id', id)
    return this.http.post(this.URI + this.uploadFileApi, formdata, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to save event
   * @class EventCalendarService
   * @method saveEvent
   * @param eventFormData
   * @returns Observable
   */

  public getAwsUrlsApi(eventDetails: any): Observable<any> {

    return this.http.post(this.URI + this.getAwsUrl, eventDetails, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to save/cancel event registration
   * @class EventCalendarService
   * @method saveEvent
   * @param eventFormData
   * @returns Observable
   */

  public saveEventRegistration(eventRegistrationDetails: any): Observable<any> {

    return this.http.post(this.URI + this.evevntRegistrationApi, eventRegistrationDetails, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to save/cancel event registration
 * @class EventCalendarService
 * @method saveEvent
 * @param eventFormData
 * @returns Observable
 */

  public saveEventForGroupRegistration(eventRegistrationDetails: any): Observable<any> {

    return this.http.post(this.URI + this.eventRegistrationForGroupApi, eventRegistrationDetails, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }
  /** For service call to get the number of members signed in
   * @class EventRegistrationService
   * @method getCountOfSignedUser
   * @param eventId
   * @returns Observable
   */
  public getCountOfSignedUser(eventId): Observable<any> {
    return this.http.post(this.URI + this.getCountOfSignedUserByEventId + eventId, {}, this.bpgCommonService.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      })).pipe(catchError((error: any) => {
        throw of(error);
      }))
  }

  /** For service call to get the signed and unsigned user
    * @class EventRegistrationService
    * @method getSignedUnsignedUser
    * @param userId,eventId
    * @returns Observable
    */
  public getSignedUnsignedUser(eventId, userId): Observable<any> {
    return this.http.post(`${this.URI}${this.getSignedUnsignedUserByEventId}${eventId}/${userId}`, {}, this.bpgCommonService.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      })).pipe(catchError((error: any) => {
        throw of(error);
      }))
  }


  /** For service call to update event status
  * @class EventCalendarService
  * @method updateEventStatus
  * @param landingDto
  * @returns Observable
  */

  public updateEventStatus(landingDto: any): Observable<any> {
    return this.http.post(this.URI + this.eventStatusUpdateApi, landingDto, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  public landingDto() {
    return {
      "approvalComment": "string",
      "approvedBy": 0,
      "eventId": 0,
      "eventStatus": "NEW",
    }
  }


  /** For service call to save User Attendance
   * @class EventCalendarService
   * @method saveUserAttendance
   * @param UserAttendanceDetails
   * @returns Observable
   */
  public saveUserAttendance(UserAttendanceDetails: any): Observable<any> {

    return this.http.post(this.URI + this.evevntAttendanceApi, UserAttendanceDetails, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to update expense status
   * @class EventCalendarService
   * @method updateExpenseStatus
   * @param landingDto
   * @returns Observable
   */

  public updateExpenseStatus(landingDto: any): Observable<any> {
    return this.http.post(this.URI + this.expenseStatusUpdateApi, landingDto, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  public landingDto1() {
    return {
      "approvalComment": "string",
      "approvedBy": 0,
      "expenseId": 0,
      "expenseStatus": "NEW",
    }
  }

  /** For service call to get std survey question/answer
  * @class EventService
  * @method getSurveyStdQuestionAnswers
  * @param landingDto
  * @returns Observable
  */

  public getSurveyStdQuestionAnswers(landingDto: any): Observable<any> {
    return this.http.post(this.URI + this.surveyStandardQuestionAnswersApi, landingDto, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to get the Questions and Answers For the Events
  * @class TakeSurveyService
  * @method getQuestionAnswers
  * @param userId,eventId
  * @returns Observable
  */
  public getQuestionAnswers(landingData: any): Observable<any> {
    return this.http.post(this.URI + this.takeSurveyListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    })).pipe(catchError((error: any) => {
      throw of(error);
    }))
  }

  /** For service call to save Servey
   * @class TakeSurveyComponent
   * @method saveResponseSurvey
   * @param UserAttendanceDetails
   * @returns Observable
   */
  public saveResponseSurvey(SurveyResopnseDetails: any): Observable<any> {

    return this.http.post(this.URI + this.saveSurveyResponseApi, SurveyResopnseDetails, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to create a survey
  * @class EventService
  * @method getSurveyStdQuestionAnswers
  * @param landingDto
  * @returns Observable
  */

  public createSurvey(landingDto: any): Observable<any> {
    return this.http.post(this.URI + this.createSurveyApi, landingDto, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }

  /** For service call to get the All Std Questions and Answers For the Survey
  * @class EventService
  * @method getSurveyQuestions
  * @param landingDto
  * @returns Observable
  */
  public getSurveyQuestions(landingDto: any): Observable<any> {
    return this.http.post(this.URI + this.getSurveyQuestionsApi, landingDto, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;

    })).pipe(catchError((error: any) => {
      throw of(error);
    }))

  }


  /** For service call to get the Survey Id and details
     * @class BpgEventsService
     * @method getSurveyId
     * @param landingData
     * @returns Observable
     */
  public getSurveyId(landingData: any): Observable<any> {
    return this.http.post(this.URI + this.getSurveyIdApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    })).pipe(catchError((error: any) => {
      throw of(error);
    }))
  }
  /** For service call to get the group sign up details
     * @class BpgEventsService
     * @method getGroupSignupDetails
     * @param landingData
     * @returns Observable
     */
  public getGroupSignupDetails(eventId, userId): Observable<any> {
    return this.http.post(`${this.URI}${this.getGroupSignupDetailsApi}${eventId}/${userId}`, {}, this.bpgCommonService.tokenizedHeader())
      .pipe(map((data: any) => {
        return data;
      })).pipe(catchError((error: any) => {
        throw of(error);
      }))
  }
    /** For service call to remove user from event sign up
     * @class BpgEventsService
     * @method removeFromEventGroup
     * @param landingData
     * @returns Observable
     */
     public removeFromEventGroup(eventId, userId): Observable<any> {
      return this.http.post(`${this.URI}${this.removeFromEventGroupApi}${eventId}/${userId}`, {}, this.bpgCommonService.tokenizedHeader())
        .pipe(map((data: any) => {
          return data;
        })).pipe(catchError((error: any) => {
          throw of(error);
        }))
    }
  /** For service call to check whether user taken the survey
     * @class BpgEventsService
     * @method suveyTakenByUser
     * @param landingData
     * @returns Observable
     */
  public suveyTakenByUser(landingData: any): Observable<any> {

    return this.http.post(this.URI + this.suveyTakenByUserApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    })).pipe(catchError((error: any) => {
      throw of(error);
    }))
  }

  /** For service call to list User Attendance data
     * @class BpgEventsService
     * @method suveyTakenByUser
     * @param landingData, eventId
     * @returns Observable
     */
  public listAttendance(landingData: any): Observable<any> {
    return this.http.post(this.URI + this.listAttendanceApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    })).pipe(catchError((error: any) => {
      throw of(error);
    }))
  }

  /** For service call to list User Attendance data
     * @class BpgEventsService
     * @method suveyTakenByUser
     * @param landingData, eventId
     * @returns Observable
     */
  public listEventReport(landingData: any): Observable<any> {
    return this.http.post(this.URI + this.listEventReportApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    })).pipe(catchError((error: any) => {
      throw of(error);
    }))
  }

  /** For converting json to csv and saving the file
     * @class BpgEventsService
     * @method exportAsExcelFile
     * @param json data, string
     */
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName.trim() + EXCEL_EXTENSION);
  }

  /** For service call to get all Events for printing
 * @class EventCalendarService
 * @method getAllEvents in fiscal year
 * @param landingData
 * @returns Observable
 */

  public getAllEventsInFiscalYear(landingData: any): Observable<any> {
    return this.http.post(this.URI + this.printEventListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }

   /** For service call to get all budgte actuals
 * @class EventCalendarService
 * @method getAllBudgetActuals
 * @param landingData
 * @returns Observable
 */

   public getBudgetActualsData(landingData: any): Observable<any> {
    return this.http.post(this.URI + this.getBudgetActualsDataApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
      return data;
    }))
      .pipe(catchError((error: any) => {
        throw of(error);
      }))
  }

}
